import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'timeConversion' } )
export class TimeConversionPipe implements PipeTransform {
    transform( pTime: number ): string {
        const duration = Math.floor(pTime);
        const hours = Math.floor(duration / 60);
        const minutes = Math.floor((duration % 60));
        return (hours >= 1 ? (hours + 'h ') : '') + (minutes >= 1 ? (minutes + 'min') : '');
    }
}
